import { Download } from "lucide-react";
import { lazy, Suspense } from "react";

const Impl = lazy(() => import("./VideoPlayerImpl.tsx"));

/** Can this browser decode the container / codec at all? Video.js cannot help when it cannot (HEVC .mov, avi, mkv …). */
export function canPlay(mime: string | undefined): boolean {
  if (!mime || !mime.startsWith("video/")) return true;
  try {
    return document.createElement("video").canPlayType(mime) !== "";
  } catch {
    return true;
  }
}

/**
 * Video attachment player: Video.js v10 in a lazy chunk (nothing loads until a video is opened). Formats the browser
 * cannot decode get a download hint instead of a black box.
 */
export function VideoPlayer({ src, mime, name, autoPlay, className = "" }: { src: string; mime?: string; name?: string; autoPlay?: boolean; className?: string }) {
  if (!canPlay(mime)) {
    return (
      <div className={`flex flex-col items-center gap-3 rounded bg-black/60 px-10 py-12 text-white/80 ${className}`}>
        <div>This browser cannot play {mime ?? "this format"}.</div>
        <a href={src} download={name} className="flex items-center gap-2 rounded border border-white/40 px-3 py-1.5 hover:border-white hover:text-white">
          <Download size={16} /> Download {name ?? "the file"}
        </a>
      </div>
    );
  }
  return (
    <div className={`gjw-video ${className}`}>
      <Suspense fallback={<video src={src} controls autoPlay={autoPlay} playsInline className="h-full w-full bg-black" />}>
        <Impl src={src} mime={mime} autoPlay={autoPlay} title={name} />
      </Suspense>
    </div>
  );
}
